module.exports = __webpack_public_path__ + "img/print-summary.5b4b9526.svg";